import { Skeleton } from "../ui/skeleton";

export default function LoadingSkeleton() {
  return (
    <div className="lg:w-[258px]">
      <header className=" lg:h-[310px] w-full bg-midnightIndigo-100 rounded mb-2 relative ">
        <Skeleton className="h-full w-full rounded" />
      </header>
      <section>
        <div>
          <Skeleton className={"h-[24px] mb-2 w-[120px]"} />
          <Skeleton className={"h-[34px]"} />
        </div>
        <div className="flex items-end  justify-between mt-10 mb-4">
          <div>
            <Skeleton className={"h-[14px] w-[120px] mb-1"} />
            <Skeleton className={"h-[24px] w-[160px]"} />
          </div>
          <Skeleton className={"h-[34px] w-[80px]"} />
        </div>
        <Skeleton className={"h-[44px] w-full"} />
      </section>
    </div>
  );
}
